/* eslint-disable import/prefer-default-export */
import isNil from 'lodash/isNil';

/**
 * 문자열에서 파라미터로 전달된 키워드와 일치하는 문자열을 강조표시한다.
 * @author Ju
 * @param  {[type]} value   [description]
 * @param  {[type]} keyword [description]
 * @return {[type]}         [description]
 */
export function highlightKeyword(value, searchKeyword) {
  let keyword = searchKeyword;
  if (/\W|[_]/g.test(keyword)) {
    keyword = keyword.replace(/\W|_/g, '[$&]');
  }

  if (isNil(value) || value === '' || isNil(keyword) || keyword === '') {
    return value;
  }

  return value.replace(new RegExp(keyword, 'gi'), (x) => `<strong>${x}</strong>`);
}



// WEBPACK FOOTER //
// ./src/views/frame/components/popup/SmartSearchPopup/utils/search.js